export default "__VITE_ASSET__Bv$1MjuI__"